import { render } from "./UserPage.vue?vue&type=template&id=f86bf76c"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=f86bf76c&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__